export interface GridDetailPanelsProps {}

export function GridDetailPanels(_: GridDetailPanelsProps) {
  return null;
}
